'use client'

import { ReactNode } from 'react'

import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  Link,
} from '@chakra-ui/react'

import Logo from './Logo'
import { useTranslation } from 'react-i18next'

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
      {children}
    </Text>
  )
}

export default function Footer() {
  const { t } = useTranslation()

  return (
    <Box
      bg={useColorModeValue('gray.50', 'gray.900')}
      color={useColorModeValue('gray.700', 'gray.200')}>
      <Container as={Stack} maxW={'6xl'} py={10}
        width={{base:'90vw',md:'80vw'}}
      >
        <SimpleGrid
          templateColumns={{ sm: '1fr 1fr', md: '3fr 1fr 1fr 1fr 1fr' }}
          spacing={8}>
          <Stack spacing={4}>
            <Box>
              <Logo />
            </Box>
            <Link isExternal href="https://goo.gl/maps/TY7v3JFMLCvvHL6X7">
              <Text fontSize={'sm'}>ul. "Konche Vihrogonche" 401A, Druzba 2, Sofia.</Text>
            </Link>
            <Link  href="tel:+359885602809">
              <Text fontSize={'sm'}>+359 88 560 2809</Text>
            </Link>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>{t('footer.courses')}</ListHeader>
            <Box as={Link} href={'/ballet'} fontSize={'sm'}>
              {t('nav.classic')}
            </Box>
            <Box as={Link} href={'/modern'} fontSize={'sm'}>
              {t('nav.modern')}
            </Box>
            <Box as={Link} href={'/stretching'} fontSize={'sm'}>
            {t('nav.stretching')}
            </Box>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>{t('footer.information')}</ListHeader>
            <Box as={Link} href={'/about'} fontSize={'sm'}>
              {t('footer.about')}
            </Box>
            <Box as={Link} href={'/login'} fontSize={'sm'}>
              {t('footer.login')}
            </Box>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>{t('footer.help')}</ListHeader>
            <Box as={Link} href={'#'} fontSize={'sm'}>
              {t('footer.privacy')}
            </Box>
            <Link isExternal href={'https://renzoparagliola.com'} fontSize={'sm'}>
              {t('footer.development')}
            </Link>
          </Stack>
         
          <Stack align={'flex-start'}>
            <ListHeader>{t('footer.follow')}</ListHeader>
            <Box as={Link} href={'https://www.facebook.com/inchilza'} fontSize={'sm'}>
              Facebook
            </Box>
            <Box as={Link} href={'https://instagram.com/inchilza.dance.studio'} fontSize={'sm'}>
              Instagram
            </Box>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  )
}
